import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { QUEUE_CONSTANTS } from '@app/shared/constants/queue.constants';
import { TabsComponent } from '@app/shared/custom-component/tabs/tabs.component';
import { MaterialUIModule } from '@app/shared/modules/material-ui/material-ui.module';
import { CommonService } from '@app/shared/services/common.service';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs';
import { BusinessRulesComponent } from '../business-rules/business-rules.component';
import { AuditTrailsComponent } from '../audit-trails/audit-trails.component';
import { ContentManagementComponent } from '../content-management/content-management.component';
import { DataGridVO } from '@app/shared/custom-component/data-grid/data-grid.model';
import { DataTemplateComponent } from '../data-template/data-template.component';

@Component({
  selector: 'app-system-configuration',
  templateUrl: './system-configuration.component.html',
  styleUrls: ['./system-configuration.component.scss'],
   standalone: true,
    imports: [CommonModule,TabsComponent, MaterialUIModule,BusinessRulesComponent , AuditTrailsComponent,DataTemplateComponent, ContentManagementComponent]
})
export class SystemConfigurationComponent implements OnInit {
  tabs = [];
  activeTab: any = QUEUE_CONSTANTS.DEFAULT_TAB;;
  systemConfigData: any[] = [];
  visibleColumns: { [key: string]: boolean } = {};
   private destroy$ = new Subject<void>();
  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.commonService.getMetaData(QUEUE_CONSTANTS.SYSTEM_CONFIGURATION_TABS).pipe(take(1), takeUntil(this.destroy$)).subscribe((res: any) => {
        this.tabs = res.tabs.filter((tab:any) => ![  'emails', 'text_management', 'ticker'].includes(tab.key));
    });
  }

  onTabSelected(tabKey: string) {
    this.selectTab(tabKey);
  }

  selectTab(tabKey: string) {
    this.activeTab = tabKey;
  }

  getActiveTabLabel(): string {
    const found = this.tabs.find(tab => tab.key === this.activeTab);
    return found ? found.label : '';
  }
}